/**
 * Прелоад больших карт-подложек.
 *
 * По ТЗ (встреча 27.08.2026, п.4): карта долго грузится каждый раз при открытии.
 * Решение — предзагрузить PNG сразу после старта приложения, до того как
 * пользователь дойдёт до карты. Файл уходит в HTTP-кэш браузера + держится
 * decoded в JS-памяти. На второе монтирование Leaflet отдаст изображение
 * мгновенно из кэша браузера (nginx уже отдаёт Cache-Control: max-age=7d).
 *
 * Дополнительно — экспортируется готовый Image, чтобы код карты мог
 * использовать его без повторного декодирования.
 */

const cache = new Map()

/**
 * Начинает загрузку изображения в фоне.
 * Кладёт готовый Image в cache под ключом url.
 * Безопасно вызывать много раз — повторный вызов работает как no-op.
 */
export function preloadImage(url) {
  if (!url) return null
  if (cache.has(url)) return cache.get(url)
  const img = new Image()
  img.decoding = 'async'
  img.loading = 'eager'
  img.src = url
  // decode() гарантирует что к моменту первой отрисовки браузер уже разобрал файл
  const entry = { img, ready: img.decode().then(() => img).catch(() => img) }
  cache.set(url, entry)
  return entry
}

/** Возвращает готовый Image из кэша (или null). */
export function getPreloaded(url) {
  const entry = cache.get(url)
  return entry ? entry.img : null
}

/** Стартует прелоад всех известных больших карт. Вызвать один раз при старте приложения. */
export function preloadKnownMaps() {
  try {
    const mapUrl = require('@/assets/images/map/maps/mapdps1.png')
    preloadImage(mapUrl)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('preloadKnownMaps: не удалось найти карту-подложку', e)
  }
}
